import {useMemo} from "react";
import {buildTimelineItems} from "./helpers/alarmTimelineHelper.jsx";
import TimelineEvents from "../../../../../components/timeline-events/timeline-events.jsx";
import platePatternUtils from "../../../../../utils/plate-pattern-utils.js";

export default function ReportContent({ data }) {
    const formattedPlate = platePatternUtils.formatPlate(data?.plate);
    const laneInfo = data?.laneInfo ?? {};

    const laneTypeMap = {
        API: "API",
        SENTRY_CLOUD: "Sentry Cloud",
        INTERNAL_SMARTCAPTURE: "Smartcapture",
        MOBILE_APP: "App Captura Móvel",
        MOBILE_CAMERA: "Móvel",
    }

    function formatLaneInfo(laneInfo) {
        if (!laneInfo) return "";

        const details = [];

        details.push(`Câmera ${laneInfo.code}`);

        if (laneInfo.type) {
            details.push(laneTypeMap[laneInfo.type] ?? laneInfo.type);
        }

        if (laneInfo.front_driver) {
            details.push(laneInfo.front_driver);
        } else if (laneInfo.back_driver) {
            details.push(laneInfo.back_driver);
        }

        return details.join(" - ");
    }

    const items = useMemo(() => {
        return buildTimelineItems(data);
    }, [data]);

    return (
        <div className="space-y-6">
            <div className="text-center space-y-1">
                <div id="plate" className="text-2xl">{formattedPlate}</div>
                <div className="font-semibold text-[12px]">{formatLaneInfo(laneInfo)}</div>
            </div>
            <TimelineEvents items={items} />
        </div>
    )
}